import { forwardRef, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetJenisMobil } from "../api/api-get-jenis-mobil";
import { Column } from "primereact/column";
import JenisMobilFilter from "./jenis-mobil-filter";
import {
  genTemplateBodyText,
  genTemplateBodyImage,
} from "@components/utils/TableTemplateBodyGenerator";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";

const JenisMobilList = forwardRef((props, ref) => {
  const { onClickRowEdit } = props;

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
  } = useAPIGetJenisMobil();

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
  }));

  // use effect section

  useEffect(() => {
    fetchListData({ page: paging.page, take: paging.take });
  }, []);

  //  custom ui section

  const namaBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "nama",
    });
  };

  const gambarDepanBodyTemplate = (row) =>
    genTemplateBodyImage({ row, field: "gambar_depan", preview: true });
  const gambarBelakangBodyTemplate = (row) =>
    genTemplateBodyImage({ row, field: "gambar_belakang", preview: true });
  const gambarKananBodyTemplate = (row) =>
    genTemplateBodyImage({ row, field: "gambar_kanan", preview: true });
  const gambarKiriBodyTemplate = (row) =>
    genTemplateBodyImage({ row, field: "gambar_kiri", preview: true });

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          icon="pi pi-pencil"
          rounded
          severity="primary"
          className="bg-indigo-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onClickRowEdit) onClickRowEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      </div>
    );
  };

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <div className="elevated-card-tight-vertical row-start-start w-full gap-4">
        <JenisMobilFilter
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onClickRefresh={handleOnClickRefresh}
        />
      </div>

      {/* table section */}
      <div className="elevated-card-tight-vertical col-start-end w-full gap-2">
        <DataTable
          dataKey="id"
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          value={listData}
        >
          <Column
            field="no"
            header="#"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader={"center"}
          />
          <Column
            field=""
            header="Action"
            alignHeader={"center"}
            headerClassName="w-[6rem]"
            body={actionBodyTemplate}
          />
          <Column field="nama" header="Nama" body={namaBodyTemplate} />
          <Column
            header="Foto Depan"
            headerClassName="w-[6rem]"
            body={gambarDepanBodyTemplate}
          />
          <Column
            header="Foto Belakang"
            headerClassName="w-[6rem]"
            body={gambarBelakangBodyTemplate}
          />
          <Column
            header="Foto Kiri"
            headerClassName="w-[6rem]"
            body={gambarKiriBodyTemplate}
          />
          <Column
            header="Foto Kanan"
            headerClassName="w-[6rem]"
            body={gambarKananBodyTemplate}
          />
        </DataTable>
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
        />
      </div>
    </div>
  );
});

export default JenisMobilList;
